import React, {useMemo} from "react";
import {uid} from "react-uid";
import InfiniteScroll from 'react-infinite-scroller';

import LinearProgress from "@material-ui/core/LinearProgress";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PropTypes from "prop-types";
import {usePaginatedData} from "./usePaginatedData";
import OptionsMenu from "./OptionsMenu";
import RenderChildren from "./RenderChildren";
import {generateBorder} from "../../../Utils/generateStyles";
import {Typography} from "@material-ui/core";

const useStyles = makeStyles(() => ({
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
        '&:hover': {
            // boxShadow: 'rgb(136, 136, 136) 0px 1px 2px 0px',
            '& $optContainer': {
                visibility: 'visible',
            }
        }
    }
}));

const SimpleForEach = (props) => {
    const {
        arrayToRender, creatable, removable, adaptiveWidth, editScreen, addGroup, removeGroup, path,
        containerArrayPath, children, styles, list, events, containerId, noDataLabel, maxItemsRender,
        skipInitDataLoad
    } = props;
    let borderObj = generateBorder(styles);
    const [content, dataLength, hasMore, loadMore] = usePaginatedData(list, events, skipInitDataLoad);
    const containerStyles = {
        overflow: 'auto',
        display: 'flex', flexWrap: 'wrap',
        width: '100%',
        flexDirection: 'row',
        ...borderObj,
        ...styles,
        borderRadius: styles.borderRadius,
        borderColor: styles.borderColor,
        borderStyle: styles.borderStyle || 'solid',
    };
    const containerID = containerId ? containerId : uid(list ? list : path || '');
    return (
        <div style={{...containerStyles, width: '100%'}} className={styles.className} id={containerID}>
            {list ? (
                <InfiniteScroll loadMore={loadMore}
                                hasMore={hasMore}
                                loader={<LoadMore/>}
                                dataLength={dataLength}
                                getScrollParent={containerID ? () => document.getElementById(containerID) : null}
                                pageStart={0}
                                useWindow={!containerID}
                                style={{width: '100%'}}
                >
                    <div style={{display: 'flex', flexWrap: 'wrap', width: '100%'}}>
                    <MemoizedRenderArray
                        array={content}
                        creatable={creatable}
                        removable={removable}
                        adaptiveWidth={adaptiveWidth}
                        editScreen={editScreen}
                        addGroup={addGroup}
                        removeGroup={removeGroup}
                        path={path}
                        containerArrayPath={undefined}
                        children={children}
                        styles={styles}
                        noDataLabel={noDataLabel}
                        maxItemsRender={maxItemsRender}
                    />
                    </div>

                </InfiniteScroll>
                ) : (
                <MemoizedRenderArray
                    array={arrayToRender}
                    creatable={creatable}
                    removable={removable}
                    adaptiveWidth={adaptiveWidth}
                    editScreen={editScreen}
                    addGroup={addGroup}
                    removeGroup={removeGroup}
                    path={path}
                    containerArrayPath={containerArrayPath}
                    children={children}
                    styles={styles}
                    noDataLabel={noDataLabel}
                    maxItemsRender={maxItemsRender}
                />
            )}
        </div>
    )
}
export default SimpleForEach

SimpleForEach.propTypes = {
    adaptiveWidth: PropTypes.string,
    arrayToRender: PropTypes.array,
    containerArrayPath: PropTypes.string,
    creatable: PropTypes.bool,
    removable: PropTypes.bool,
    path: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    editScreen: PropTypes.string,
    addGroup: PropTypes.func,
    removeGroup: PropTypes.func,
    styles: PropTypes.object
}
const RenderArray = (props) => {
    const {
        array, creatable, removable, adaptiveWidth, noDataLabel, maxItemsRender,
        editScreen, addGroup, removeGroup, path, containerArrayPath, children, styles = {}
    } = props;
    const classes = useStyles();
    const arrToRender = useMemo(() => {
        return maxItemsRender ? array.slice(0, maxItemsRender) : array;
    }, [JSON.stringify(array), maxItemsRender])
    if (!array.length && noDataLabel) {
        return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
            <Typography variant={"body2"} color={"textSecondary"}>{noDataLabel ? noDataLabel : "No Data"}</Typography>
        </div>
    }

    return (
        (arrToRender.length ? arrToRender : [{}]).map((value, valueIndex) => (
                <div key={uid(valueIndex)}
                     className={classes.container}
                     style={{
                         padding: (creatable || removable) && '2px 0 2px 15px',
                         width: adaptiveWidth || '100%',
                         justifyContent: styles.justifyContent ? styles.justifyContent : '',
                         alignItems: styles.alignItems ? styles.alignItems : 'baseline'
                     }}
                >
                    <OptionsMenu
                        creatable={creatable}
                        removable={removable}
                        editScreen={editScreen}
                        addGroup={addGroup}
                        removeGroup={removeGroup}
                        path={path}
                        valueIndex={valueIndex}
                    />
                    <RenderChildren
                        path={containerArrayPath ? containerArrayPath : path}
                        children={children}
                        value={value}
                        valueIndex={valueIndex}
                        toRenderLength={arrToRender.length}
                        arrLength={array.length}
                    />
                </div>
            )
        )
    )
}
const LoadMore = () => {
    return (
        <div>
            <LinearProgress/>
        </div>
    )
};
const MemoizedRenderArray = React.memo(RenderArray);